import { PopoverPlacement } from "@idui/react-popover";
import { FC, useMemo } from "react";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { DATA_E2E_KEY, IPassengerInfo, IStyledAttributes } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";

const HasDogPassengersTooltipContentWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-passenger-has-dog-tooltip",
  },
)`
  display: flex;
  align-items: center;
  font-size: 1.2em;
  white-space: nowrap;
  line-height: 1.4em;
  padding: 0 6px;

  .passenger-name {
    font-weight: 700;
  }

  .passenger-id {
    font-size: 14px;
  }

  .separator {
    margin: 0 5px;
  }
`;

interface IRidePassengersHasDog {
  passengers: IPassengerInfo[];
}

export const RidePassengersHasDog: FC<IRidePassengersHasDog> = ({
  passengers,
}) => {
  const passengersList = useMemo(() => {
    return passengers
      .filter(passenger => passenger.hasDog)
      .map(passenger => (
        <HasDogPassengersTooltipContentWrapper>
          <span className="passenger-name">{`${passenger?.firstName} ${passenger?.lastName}`}</span>
          <span className="separator">|</span>
          <span className="passenger-id">{passenger?.id}</span>
        </HasDogPassengersTooltipContentWrapper>
      ));
  }, [passengers]);

  return (
    <>
      {Boolean(passengersList.length) && (
        <FramerTooltip
          content={passengersList}
          placement={PopoverPlacement.bottom}
        >
          <SVG_MUI.DogCircle4SVG />
        </FramerTooltip>
      )}
    </>
  );
};
